export const APP_NAME = 'ERP Springs-project'

const nodeEnv = getEnvVar('NODE_ENV')
export const IS_DEVELOPMENT_MODE = nodeEnv === 'development'
export const IS_PRODUCTION_MODE = nodeEnv === 'production'

function getEnvVar (key) {
  const envVar = process.env[key]
  if (envVar === undefined) {
    throw new Error(`Env variable ${key} is required`)
  }
  return envVar
}
